<template>
    <div>
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Mandatsreferenznummern') }}
            <img
                src="@img/info.png"
                alt=""
                :title="$t('club.mandateReferenceNumberConfig.mandateReferenceNumber.help')"
            />
        </h3>

        <div>
            <div class="kgr-inputGroup">
                <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters">
                    <div class="kgr-grid__cell">
                        <div class="animated fadeIn">
                            <kgr-form-row
                                :label="$t('Kürzel')"
                                :error="error"
                                field-name="mandateReferenceNumberConfig.prefix"
                            >
                                <input
                                    v-model.trim="mandateReferenceNumberConfig.prefix"
                                    type="text"
                                    class="kgr-input"
                                    maxlength="10"
                                    @keyup.enter="onKeyUpEnter"
                                />
                            </kgr-form-row>
                        </div>
                    </div>
                    <div class="animated fadeIn kgr-grid__cell">
                        <div class="kgr-region kgr-region--rounded kgr-region--gray">
                            <div class="kgr-row">
                                {{ $t('So könnte eine Mandatsreferenznummer aussehen') }}:
                            </div>
                            <div class="invoiceSettingsPreview kgr-text kgr-text--bold">
                                {{ mandateReferenceNumberPreview }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import MandateReferenceNumberConfig from '../../../js/dto/MandateReferenceNumberConfig';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        mandateReferenceNumberConfig: {
            type: MandateReferenceNumberConfig,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    computed: {
        mandateReferenceNumberPreview() {
            const separator = '-';
            const counter = '001';
            const number = '10000';
            let prefix = '';
            if (this.mandateReferenceNumberConfig.prefix !== '') {
                prefix = this.mandateReferenceNumberConfig.prefix + separator;
            }

            return prefix + number + separator + counter;
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
